import {Repository} from "../../persistence/repository";
import {WeeklyWorkingTime} from "../entities/weekly-working-time.entity";
import {Employee} from "../entities/employee.entity";
import {plainToInstance} from "class-transformer";
import {WeeklyWorkingTimeDto} from "../dtos/weekly-working-time.dto";
import {EntityState} from "../../persistence/entity-state.enum";
import {ChangeTracker} from "../../change-tracking/change-tracker";
import {ShortIdHelper} from "../../helpers/short-id.helper";
import {PROPERTY_PUBLIC} from "../../property-public.symbol";
import {singleton} from "tsyringe";
import {persistence} from "../../decorators/persistence.decorator";

@singleton()
@persistence({
    entity: WeeklyWorkingTime
})
export class WeeklyWorkingTimeRepository extends Repository<WeeklyWorkingTime> {

    /**
     * Creates a new weekly working time with the default hours for the given employee and
     * registers it as NEW. Always resolves the created entity, never null.
     */
    public create(employee: Employee): Promise<WeeklyWorkingTime> {

        // The plain object carries the Employee itself, not its uid as a WeeklyWorkingTimeDto
        // would, so it is typed as what it is.
        const weeklyWorkingTime = plainToInstance<WeeklyWorkingTime, Omit<WeeklyWorkingTimeDto, `employee`> & { employee: Employee }>(WeeklyWorkingTime, {
            uid: ShortIdHelper.generate(),
            employee: employee,
            monday: 8,
            tuesday: 8,
            wednesday: 8,
            thursday: 8,
            friday: 8,
            saturday: 0,
            sunday: 0
        }, {
            excludeExtraneousValues: true
        });

        const weeklyWorkingTimeProxy = ChangeTracker.create(weeklyWorkingTime);

        this.entityManager.setLoadedEntity(weeklyWorkingTimeProxy, EntityState.NEW);

        return Promise.resolve(weeklyWorkingTimeProxy);
    }

    public update(weeklyWorkingTime: WeeklyWorkingTime, data: Partial<WeeklyWorkingTimeDto>): WeeklyWorkingTime {
        const publicProperties: Array<keyof WeeklyWorkingTimeDto> = Reflect.getMetadata(PROPERTY_PUBLIC, weeklyWorkingTime.constructor)

        const filteredData = Object.entries(data).filter(
            ([key, _]: [keyof WeeklyWorkingTimeDto, any]) => publicProperties.includes(key as string)
        );

        const filteredDataObject = Object.fromEntries(filteredData);

        return Object.assign(weeklyWorkingTime, filteredDataObject);
    }
}